import { Loader2, Mic, MicOff } from 'lucide-react';
import { t } from '@/i18n';
import { useAudioState } from '@/hooks/useAudio';
import './MicStatusPill.css';

/**
 * Microphone status in the header.
 *
 * Deliberately **not** a control. The microphone is only useful on a training
 * screen, and those screens ask for it properly — with an explanation and a
 * full-width button. A second, tiny way to trigger the permission prompt from a
 * screen that cannot use the result is a control with no purpose, and it made
 * the indicator flicker off again once the lease expired.
 */
export function MicStatusPill() {
  const state = useAudioState();

  const busy = state.status === 'requesting' || state.status === 'calibrating';
  const live = state.status === 'ready';
  const label = busy ? t('mic.checking') : live ? t('mic.active') : t('mic.off');

  return (
    <span
      className={`mic-pill mic-pill--${live ? 'live' : busy ? 'busy' : 'off'}`}
      role="status"
      aria-label={label}
    >
      {busy ? (
        <Loader2 size={17} className="mic-pill__spin" aria-hidden="true" />
      ) : live ? (
        <Mic size={17} aria-hidden="true" />
      ) : (
        <MicOff size={17} aria-hidden="true" />
      )}
      <span className="mic-pill__label">{label}</span>
    </span>
  );
}
